// extracted by mini-css-extract-plugin
export default {"tick":"styles__tick___fSith","tickSelected":"styles__tickSelected___yo9KY","cross":"styles__cross___CvBUB","crossSelected":"styles__crossSelected___KQSA6"};